// Small icon strip shown next to a gamer_tag when their platforms are linked.
// Uses colored letter tiles so it works without any external icon font.
const PLATFORMS = [
    { key: "xbox_gamertag", label: "Xbox",    short: "X", color: "#107C10" },
    { key: "psn_id",        label: "PSN",     short: "P", color: "#0070D1" },
    { key: "steam_id",      label: "Steam",   short: "S", color: "#00ADEE" },
    { key: "discord_tag",   label: "Discord", short: "D", color: "#5865F2" },
];

const SIZES = {
    xs: { box: "w-3.5 h-3.5", font: "text-[9px]" },
    sm: { box: "w-4 h-4",   font: "text-[10px]" },
    md: { box: "w-5 h-5",   font: "text-[11px]" },
};

export function PlatformIcons({ user, size = "sm", className = "", testId }) {
    if (!user) return null;
    const active = PLATFORMS.filter(p => (user[p.key] || "").toString().trim() !== "");
    if (active.length === 0) return null;
    const s = SIZES[size] || SIZES.sm;
    return (
        <span className={`inline-flex items-center gap-1 ${className}`} data-testid={testId}>
            {active.map(p => (
                <span
                    key={p.key}
                    title={`${p.label}: ${user[p.key]}`}
                    className={`${s.box} ${s.font} inline-flex items-center justify-center font-display font-black`}
                    style={{ background: p.color, color: "#fff", lineHeight: 1 }}
                    data-testid={testId ? `${testId}-${p.label.toLowerCase()}` : undefined}
                >
                    {p.short}
                </span>
            ))}
        </span>
    );
}

export { PLATFORMS };
